import React, { useEffect, useState } from "react";
import { questions } from "../schema.js";
import Results from "./Results"; // Importing the Results component for displaying results
import Welcome from "./Welcome"; // Importing the Welcome component for the initial page
import Question from "./Question"; // Importing the Question component for rendering questions
import { colors, transitionLength } from "../config.js"; // Importing color configurations and transition length from an external source

const Homepage = () => {
  // State variables to track the current step, data for each question, and the transitioning state
  const [step, setStep] = useState(0);
  const [data, setData] = useState(
    // Initializing data for each question based on the schema
    questions.map((question) => ({
      colors: Object.fromEntries(
        Object.keys(question.options).map((key) => [key, false])
      ),
      ratherNot: false,
      suffix: question.suffix
        ? Object.fromEntries(
            Object.keys(question.suffix).map((key) => [key, false])
          )
        : [],
    }))
  );
  const [transitioning, setTransitioning] = useState(false);

  // Effect hook to update the background color of the document
  useEffect(() => {
    document.body.style.background = colors.bg[0];
  });

  // Function to transition to the next step in the questionnaire
  const nextStep = () => {
    setTransitioning(true); // Set transitioning state to true to initiate the transition effect
    setTimeout(() => {
      setTransitioning(false); // Reset transitioning state after the transition effect duration
      setStep(step + 1); // Move to the next step
    }, transitionLength);
  };
  const previousStep = () => {
    setTransitioning(true); // Set transitioning state to true to initiate the transition effect
    setTimeout(() => {
      setTransitioning(false); // Reset transitioning state after the transition effect duration
      setStep(step - 1); // Move to the next step
    }, transitionLength);
  };

  // Function to update the data for the current question
  const setQuestionData = (update) => {
    const newData = { ...data }; // Create a copy of the current data
    newData[step - 1] = update; // Update the data for the current step
    setData(newData); // Set the updated data
  };

  // Determine the content to render based on the current step
  // console.log(data);
  if (step === 0)
    return (
      <div
        style={{
          maxWidth: "700px",
          height: "100vh",
          margin: "0 auto",
          transition: `all ${(transitionLength / 15) * 7}ms ease`, // Apply a transition effect to the entire component
          opacity: transitioning ? "0" : "1", // Adjust opacity during transitions
        }}
      >
        {" "}
        <Welcome start={nextStep} />
      </div>
    );
  // Display the Welcome component for the initial step
  else if (step > questions.length)
    return (
      <div
        style={{
          maxWidth: "700px",
          height: "100vh",
          margin: "0 auto",
          transition: `all ${(transitionLength / 15) * 7}ms ease`, // Apply a transition effect to the entire component
          opacity: transitioning ? "0" : "1", // Adjust opacity during transitions
        }}
      >
        <Results data={data} previous={previousStep} />
      </div>
    );
  // Display the Results component when all questions are answered
  // Display the Question component for the current step
  else
    return (
      <div
        style={{
          maxWidth: "700px",
          height: "100vh",
          margin: "0 auto",
          transition: `all ${(transitionLength / 15) * 7}ms ease`, // Apply a transition effect to the entire component
          opacity: transitioning ? "0" : "1", // Adjust opacity during transitions
        }}
      >
        <Question
          schema={questions[step - 1]} // Pass the schema for the current question
          data={data[step - 1]} // Pass the data for the current question
          setData={setQuestionData} // Pass the function to update question data
          submit={nextStep} // Pass the function to transition to the next step
          previous={previousStep}
          isLast={step === questions.length} // Indicate if it's the last question
        />
      </div>
    );
};

export default Homepage;
